const stepCards = document.querySelectorAll('.step-card');

if(stepCards) {
    let timeout = 0;
const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if(entry.intersectionRatio > 0) {
            setTimeout(() => {
                entry.target.classList.add('shown');
                timeout += 100;
            }, timeout);
        }
    })
})

    stepCards.forEach(stepCard => {
        observer.observe(stepCard);
    })
}
